const partnershipsAltTextI18nDe = {
  'altTextMonikaImage': 'Dr. Monika Hauck Gründerin Repair Rebels - Markenpartnerschaften',
  'altTextExpertiseImage': 'Repair Rebels Expertise – White-Label-Reparaturplattform für Modemarken',
  'altTextBikeImage': 'Nachhaltige Mode Kreislaufwirtschaft Fahrrad Reparatur',
};

export default partnershipsAltTextI18nDe;
